import { buildSupportMailto, SUPPORT_EMAIL, SUPPORT_LINKS } from "./support-links";

// Support card (GUARD-WEB-SUPPORT-POLISH) - quiet links at the bottom of Field Status. Public
// pages open in a new tab; the email link carries a version-tagged subject so support triage
// starts pre-filled. Zero buttons: nothing here competes with the capture flow.

export function SupportCard({ appVersion }: { appVersion: string }) {
  return (
    <div className="supportcard" role="group" aria-label="Help and support">
      <h3 className="supportcard__title">Help &amp; support</h3>
      <nav className="supportcard__links" aria-label="Public pages">
        {SUPPORT_LINKS.map((link) => (
          <a key={link.href} className="supportcard__link" href={link.href} target="_blank" rel="noopener noreferrer">
            {link.label}
          </a>
        ))}
      </nav>
      <a className="supportcard__email" href={buildSupportMailto(appVersion)}>
        {SUPPORT_EMAIL}
      </a>
    </div>
  );
}
